import { Observable } from 'rxjs/Rx';
import { Message } from './message';
export class ConfigService {

    msg: Message;
    public constructor(){
        this.msg = new Message(); 
    }

    //public url: String = "http://localhost:8000/api";
    //public url: String = "http://nextstoreapi.local/api";
    //public url: String = "http://52.43.47.228/api";
    
    // public admin_api: String = "https://app.dinami.ec:8010/api";
    // public reports_api: String = "http://localhost:8080/Reportes/reportes/";
    // public factelec_api: String = "http://localhost:8080/api";
    // public factelec_api: String = "https://facturacion.dinami.ec:8888/api";
    // public uploadfile_api: String = "http://localhost:3300/api";
    // public uploadfile_api: String = "https://app.dinami.ec:3300/api";

    public onSuccessResponse(res) {
        if (res) {
            if (res.status == 201) {
                return {response: res, message: this.msg.Response201};
            }
            else if (res.status == 200) {
                return res.json();
            }
            else if (res.status == 204) {
                return {response: res, message: this.msg.Response204};
            }
        }
    }
    public onErrorResponse(error) {
        let message = error.json().message;
        if (error.status == 0) {
            return Observable.throw(new Error(message?message:this.msg.Response0));
        }else if (error.status == 500) {
            return Observable.throw(new Error(message?message:this.msg.Response500));
        }
        else if (error.status == 400) {
            return Observable.throw(new Error(message?message:this.msg.Response400));
        }
        else if (error.status == 401) {
            return Observable.throw(new Error(message?message:this.msg.Response401));
        }
        else if (error.status == 403) {
            return Observable.throw(new Error(message?message:this.msg.Response403));
        }
        else if (error.status == 404) {            
            return Observable.throw(new Error(message?message:this.msg.Response404));
        }
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/config/config-service.ts